<div class="setup-guide-banner automated-setup">
  <div class="banner-header">
    <lucide-icon name="rocket" class="header-icon" [size]="20" [strokeWidth]="2"></lucide-icon>
    <h3 class="banner-title">Automated Setup (Recommended)</h3>
  </div>
  <p class="banner-description">
    Download and run our automated setup script in Azure Cloud Shell or any Bash terminal with Azure CLI. It will create
    all required resources and provide you with the configuration values below.
  </p>
  <div class="setup-instructions">
    <p class="instructions-title">Quick Start:</p>
    <ol class="instructions-list">
      <li>
        <a href="#" class="download-link" (click)="onDownloadScript($event)">
          <lucide-icon name="download" [size]="14" [strokeWidth]="2"></lucide-icon>
          Download {{ scriptFilename }}
        </a>
      </li>
      <li>
        Open
        <a href="https://shell.azure.com" target="_blank" rel="noopener noreferrer" class="azure-link"
          >Azure Cloud Shell</a
        >
        (Bash mode) or use your local terminal with Azure CLI installed
      </li>
      <li>If using Cloud Shell: upload the script using the "Upload/Download files" button</li>
      <li>
        Run the script with your parameters:
        <code class="command-example"
          >bash {{ scriptFilename }} --subscription-id YOUR_SUBSCRIPTION_ID --resource-group YOUR_RESOURCE_GROUP
          --workspace-name YOUR_WORKSPACE_NAME</code
        >
      </li>
      <li>Copy the 6 output values into the form fields below</li>
    </ol>
  </div>
  <div class="help-section">
    <lucide-icon name="info" class="help-icon" [size]="14" [strokeWidth]="2"></lucide-icon>
    <div class="help-text">
      <div class="help-title">Need to find your Azure resources?</div>
      <div class="help-subtitle">Option 1: Use Azure Portal (Recommended if you lack CLI permissions)</div>
      <div class="help-instructions">
        • Go to
        <a href="https://portal.azure.com" target="_blank" rel="noopener noreferrer" class="azure-portal-link"
          >portal.azure.com</a
        ><br />
        • Find Subscription ID: Click "Subscriptions" in the left menu<br />
        • Find Resources: Navigate to your Log Analytics workspace and copy Workspace Name, open the Resource Group link
        and copy the Resource Group Name
      </div>
      <div class="help-subtitle">Option 2: Use Azure CLI commands</div>
      <div class="cli-commands">
        <code class="cli-command">az account list --output table</code>
        <code class="cli-command">az group list --output table</code>
        <code class="cli-command">az monitor log-analytics workspace list --output table</code>
      </div>
    </div>
  </div>
</div>
